import { render, staticRenderFns } from "./RouterList.vue?vue&type=template&id=47b94544&"
import script from "./RouterList.vue?vue&type=script&lang=js&"
export * from "./RouterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports